export const VNPAY_GATEWAY_SANDBOX_HOST = 'https://sandbox.vnpayment.vn';

export const PAYMENT_ENDPOINT = 'paymentv2/vpcpay.html';
export const QUERY_DR_REFUND_ENDPOINT = 'merchant_webapi/api/transaction';
export const GET_BANK_LIST_ENDPOINT = 'qrpayauth/api/merchant/get_bank_list';
